import "./certificate.scss";
import Grid from "@mui/material/Grid2";

const CertiCard = ({ data, icon2 }) => {
  return (
    <Grid size={{ xs: 10, sm: "auto", md: "auto" }} >
      <div className="certi_card">
        <div className="certifi_img">
           <img  loading="lazy" src={data.img} alt={data.img} />
        </div>
        <div className="certi_info">
          <div className="certi_title">{data.title}</div>
          <div className="certi_number">
             <img  loading="lazy"
              src={icon2 ? "/images/num_icon2.svg" : "/images/num_icon1.svg"}
              alt="icon"
              className="certi_num_icon"
            />
            {data.number}
          </div>
        </div>
      </div>
     </Grid>
  );
};

export default CertiCard;
